export function handleFetchedErrors(response) {
	if (!response.ok) {
		throw Error(response.statusText);
	}

	return response;
}



// WEBPACK FOOTER //
// ./react-app-src/shared/utils.js